const networkConfig = {
  auth: {
    login: "/auth/admin/login",
    forgotPassword: "/auth/admin/password-forgot",
    verifyOtp: "/auth/admin/otp/verify",
    resetPassword: "/auth/admin/password",
    profile: "/admin/auth/profile", // get // put
    updateProfilePic: "/admin/auth/profile-img",
    updatePassword: "/admin/auth/password",
  },
  users: {
    getAllUsers: "/admin/users",
    unblockUser: "/admin/users",
    blockUser: "/admin/users",
    getUserDetails: "/admin/users",
  },
  chest: {
    getAllChest: "/admin/chest",
  },
  dashboard: {
    getDashboardStats: "/admin/dashboards/count-stats",
    getTopSelling: "/admin/dashboards/top-selling-items",
    getGamePerformance: "/admin/dashboards/game-performance",
    getRevenueGrowth: "/admin/dashboards/monthly-revenue",
  },
  spinWheel: {
    spinWheel: "/admin/spin-wheel",
  },
  leaderboard: {
    leaderboard: "/admin/leaderboard",
  },
  ads: {
    getAds: "/admin/ads-config",
    createAds: "/admin/ads-config",
    deleteAds: "/admin/ads-config",
  },
  salesAndInventory: {
    getSalesStats: "/admin/sales/count-stats",
    getAllShopItems: "/admin/shop-items",
    getSnake: "/admin/shop-items/snake-skins",
    getBackground: "/admin/shop-items/backgrounds",
    getPowerUp: "admin/shop-items/power-ups/price",
  },
  coins: "/admin/coins",
  notification: "/admin/notifications",
  support: "/admin/supports",
};

export default networkConfig;
